// Project Health threshold (api/src/models/health-rule-config.ts). version 0 = code default in use.
export interface HealthRule {
    key: string
    value: number
    version: number
    description: string
    effectiveFrom: string | null
    updatedAt: string | null
    updatedBy: string | null
}

export const HEALTH_RULE_LABELS: Record<string, string> = {
    // Only used for a fiscal year with no row in Admin > Project Margin Targets
    GM_TARGET: "Gross Margin Target (fallback when no FY margin target)",
    GM_GOOD_MIN: "Gross Margin — Good minimum (fallback when no FY margin target)",
    GM_WARNING_MIN: "Gross Margin — Warning minimum (fallback when no FY margin target)",
    UNBILLED_MAX_DAYS: "Unbilled Revenue — max days",
    FORECAST_CRITICAL_MONTHS: "Forecast vs Budget — critical window (months)",
    PLANNED_SPEND_TOLERANCE_PCT: "Planned Spend — tolerance (%)",
    AR_WARNING_DAYS: "AR Aging — warning days",
    AR_CRITICAL_DAYS: "AR Aging — critical days",
    AR_CRITICAL_AMOUNT: "AR Aging — critical amount ($)",
}

export const healthRuleLabel = (key: string) => HEALTH_RULE_LABELS[key] ?? key
